// // src/config.js
// const backendUrl = process.env.REACT_APP_BACKEND_URL || "https://ticketsys-api-heroku-stg-198488be73d2.herokuapp.com";
// const clientUrl = process.env.REACT_APP_CLIENT_URL || "http://localhost:3000" || "https://www.taskersys.com";

// export { backendUrl, clientUrl };





// // src/config.js

// const isProduction = process.env.NODE_ENV === 'production';

// // In production, use same-origin relative API paths
// const backendUrl = isProduction
//     ? '' // relative path like /api/signin
//     : 'http://localhost:8080'; // local dev backend

// // Client URL for OAuth redirects or socket connection fallback
// const clientUrl = isProduction
//     ? 'https://www.taskersys.com'
//     : (process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000');

// export { backendUrl, clientUrl };




// // src/config.js

// const isProduction = process.env.NODE_ENV === 'production';

// // In production, prefix all API calls with /api
// const backendUrl = isProduction
//   ? '/api'                        // calls to `${backendUrl}/signin` → /api/signin
//   : 'http://localhost:8080/api';  // dev: http://localhost:8080/api/signin

// // Client URL for OAuth redirects or socket fallback
// const clientUrl = isProduction
//   ? 'https://www.taskersys.com'
//   : (process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000');

// export { backendUrl, clientUrl };



// // src/config.js
// const isProduction = process.env.NODE_ENV === 'production';

// // all API calls are under /api in prod, or http://localhost:8080/api in dev
// export const backendUrl = isProduction
//   ? '/api'
//   : 'http://localhost:8080/api';

// // this is only used for socket.ts or any absolute redirects you might need
// export const clientUrl = isProduction
//   ? 'https://www.taskersys.com'
//   : (process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000');






// src/components/config.js
const isProduction = process.env.NODE_ENV === 'production';

export const backendUrl = isProduction
  ? '/api'                  // in prod you'll call “/api/…” relative to same origin
  : 'http://localhost:8080/api'; // in dev you hit your local server

export const clientUrl = isProduction
  ? 'https://www.taskersys.com'
  : (process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000');
